module.exports = __webpack_public_path__ + "img/logo-heeman.4781bfa6.svg";